import script from "./AudioUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioUpload.vue?vue&type=script&setup=true&lang=js"

import "./AudioUpload.vue?vue&type=style&index=0&id=e37d0104&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e37d0104"]])

export default __exports__